export const appLogo = 'https://players-turf-storage.s3.ap-south-1.amazonaws.com/logo.jpeg'